var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgHot = function SvgHot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.842 14.5c-1.07-1.939-.504-3.052.322-4.102.903-1.148 1.141-2.282 1.141-2.282s.714.805.427 2.058c1.253-1.211 1.491-3.15 1.302-3.892 2.842 1.722 4.053 5.453 2.415 8.218 8.702-4.27 2.164-10.668 1.03-11.389.378.721.455 1.939-.315 2.534C9.86 1.375 6.662.5 6.662.5 7.04 2.705 5.29 5.113 3.596 6.912c-.056-.875-.126-1.484-.65-2.324-.127 1.589-1.527 2.891-1.912 4.487-.51 2.17.385 3.752 3.808 5.425z",
    fill: "#F75C2F"
  })));
};

export default SvgHot;